module.exports = __webpack_public_path__ + "static/media/155.c3e5a804.jpg";